import React from 'react';

const IconArrowRight = props => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      strokeWidth={2}>
      <path d="M5 12h14M12 5l7 7-7 7" />
    </g>
  </svg>
);

export default IconArrowRight;
